import { MenuItems } from '../../types/MenuItems';
import { MenuPageWrapper } from '../../components/MenuPageWrapper/MenuPageWrapper';
import logoNL from '../../assets/images/logo-orange.webp';
import logoCOM from '../../assets/images/logo-blue-com.webp';
import { getTranslation } from '../../constants/translations';
import { getDefinedRegion } from '../../helpers/getRegion';
import { getLocalizedImg } from '../../helpers/getLocalizedImg';

import './Login.scss';

export const Login = () => {
  const style = window.getComputedStyle(document.body as HTMLElement);

  const t = getTranslation();
  const domen = getDefinedRegion();
  const lang = domen === 'com' || domen?.includes('localhost') ? 'en' : domen;

  return (
    <MenuPageWrapper
      id={MenuItems.LOGIN}
      color={style.getPropertyValue('--turquoise')}
      title={t.LOGIN.mainTitle}
      textContent={t.LOGIN.content}
    >
      <div className="login__color-part">
        <img
          className="menu-page-wrapper__logo"
          src={getLocalizedImg(logoNL, logoCOM)}
          alt="SixTix"
        />
        <h3 className="login__title">{t.LOGIN.formTitle}</h3>
        <a
          href={`https://launch.sixtix.nl?lang=${lang}`}
          target="_blank"
          // className="login__submit menu-submit _blockLogoHover"
          className={`login__submit login__submit--${domen} menu-submit _blockLogoHover`}
          type="submit"
          rel="noreferrer"
        >
          {t.LOGIN.login}
        </a>
        <div className="login__actions-block">
          <div className="login__action">
            <p>{t.LOGIN['No account yet?']}</p>
            <a
              href={`https://launch.sixtix.nl/register?lang=${lang}`}
              target="_blank"
              rel="noreferrer"
              className="_blockLogoHover"
            >
              {t.LOGIN['Create account']}
            </a>
          </div>
          <div className="login__action">
            <a
              href={`https://launch.sixtix.nl/forgotpassword?lang=${lang}`}
              target="_blank"
              rel="noreferrer"
              className="_blockLogoHover"
            >
              {t.LOGIN['Forgot password']}
            </a>
          </div>
        </div>
        <div className="login__actions-block">
          <div className="login__action">
            <a
              href={`https://launch.sixtix.nl/amb/register?lang=${lang}`}
              target="_blank"
              rel="noreferrer"
              className="_blockLogoHover"
            >
              {t.LOGIN['Create a ticket buyer account']}
            </a>
          </div>
          <div className="login__action">
            <a
              href={`https://launch.sixtix.nl/amb/login?lang=${lang}`}
              target="_blank"
              rel="noreferrer"
              className="_blockLogoHover"
            >
              {t.LOGIN['Login as ticket buyer']}
            </a>
          </div>
        </div>
      </div>
    </MenuPageWrapper>
  );
};
